export default __webpack_public_path__ + "static/media/BCA7.8a865e2f.jpg";